import { TranslateHelper } from "../../helpers/injector.helper";
import { ValueAndType } from "../basic/formulaEditor.model";
import { BinaryOperation } from "../enums/binaryoperation.enum";
import { OperationType } from "../enums/operationtype.enum";
import { ValueType } from "../enums/valuetype.enum";
import { FormulaNodeCalculator } from "./formula.node.calculator";
import { FormulaGroups, PrimitiveFormula } from "./iformula";

export class Or extends PrimitiveFormula {
    static StaticID: string = "e56dee7b-2a88-4182-8589-3b4c91f78527";

    constructor() {
        super();
        this._ID = Or.StaticID;
        this._Name = 'Or';
        this._MaxVariableCount = 10000;
    }

    Group(): string {
        return FormulaGroups.Binary;
    }
    OrderID(): number {
        return 2;
    }
    OperationType(): OperationType {
        return OperationType.Binary;
    }
    BinaryOperation(): BinaryOperation {
        return BinaryOperation.Or;
    }
    OperationValue(): string {
        return this.Name() + '(' + TranslateHelper.TranslatorInstance.instant('@@Wert1') + '; ...; ' + TranslateHelper.TranslatorInstance.instant('@@WertX') + ')';
    }

    Calc(fnc: FormulaNodeCalculator, maxType: ValueType, args?: ValueAndType[]): ValueAndType {
        var retVal: ValueAndType = {
            Type: ValueType.Bool,
            Value: false
        };
        if (args) {
            args.some(function (item) {
                if (item.Type == ValueType.Bool) {
                    if (typeof item.Value === 'boolean') {
                        retVal.Value = retVal.Value || item.Value;
                    }
                }
                return retVal.Value;
            });
        }
        return retVal;
    }
}